// extracted by mini-css-extract-plugin
export default {"pageWrap":"Bb-z","fullWidth":"Cb-z","heading":"Db-z","fullBleed":"Eb-z","hidden":"Fb-z"};